// extracted by mini-css-extract-plugin
module.exports = {"UnorderedList":"UnorderedList_UnorderedList__LKAki","paragraph":"UnorderedList_paragraph__RgOOq","list":"UnorderedList_list__p3aoS"};